export default __webpack_public_path__ + "static/media/cli-alph-lag-ingleses.83bc2268.png";